import * as React from "react";

import {
  type EventVisibilitySubject,
  makeEventVisibilityResolver,
  useVizState,
} from "@/shared/state/visualization";

// The resolver itself lives in the state layer (beside `settings.ts`) so
// reducer logic can share it; this module re-exports it for the component
// tree and adds the hook.
export {
  type EventVisibilitySubject,
  makeEventVisibilityResolver,
} from "@/shared/state/visualization";

/**
 * The current workspace's event visibility resolver, rebuilt only when the
 * overrides map or the rule changes.
 */
export function useEventVisibilityResolver(): (
  event: EventVisibilitySubject,
) => boolean {
  const state = useVizState();
  const eventConfigs = state.events;
  const rule = state.settings?.events;

  return React.useMemo(
    () => makeEventVisibilityResolver(eventConfigs, rule),
    [eventConfigs, rule],
  );
}
